module.exports = __webpack_public_path__ + "static/media/human8.2c05c246.jpg";